import * as React from "react";
import {useNavigate} from "react-router-dom";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Stack from "@mui/material/Stack";
import LogoutIcon from "@mui/icons-material/Logout";
import EditNoteRoundedIcon from "@mui/icons-material/EditNoteRounded";
import InventoryRoundedIcon from "@mui/icons-material/InventoryRounded";
import ForwardToInboxIcon from '@mui/icons-material/ForwardToInbox';
import SubjectIcon from '@mui/icons-material/Subject';

import {logout} from "../feature/auth/authSlice";
import {useDispatch} from "react-redux";
import SettingsIcon from '@mui/icons-material/Settings';


type MenuItem = {
  text: string;
  icon: React.ReactNode;
  path: string;
  action?: () => void;
};

const MenuContent: React.FC = () => {
  const navigate = useNavigate(); // React Router hook for navigation

  const mainListItems: MenuItem[] = [
    {text: "Marketing", icon: <ForwardToInboxIcon/>, path: "/sendSpam"},
    {text: "Templates", icon: <SubjectIcon/>, path: "/templates"},
    {text: "Email list", icon: <InventoryRoundedIcon/>, path: "/emailList"},
    {text: "Settings", icon: <SettingsIcon/>, path: "/settings"},
    {text: "Logs", icon: <EditNoteRoundedIcon/>, path: "/logs"},
  ];

  const dispatch = useDispatch();
  const secondaryListItems: MenuItem[] = [
    {
      text: "Logout", icon: <LogoutIcon/>, path: "/logout", action: () => {
        dispatch(logout());
      }
    },
  ];

  return (
    <Stack sx={{flexGrow: 1, p: 1, justifyContent: "space-between"}}>
      {/* Main Navigation */}
      <List dense>
        {mainListItems.map((item, index) => (
          <ListItem key={`li_m_${index}`} disablePadding sx={{display: "block"}}>
            <ListItemButton onClick={
              () => {
                navigate(item.path)
              }
            }>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text}/>
            </ListItemButton>
          </ListItem>
        ))}
      </List>

      {/* Secondary Navigation */}
      <List dense>
        {secondaryListItems.map((item, index) => (
          <ListItem key={`li_${index}`} disablePadding sx={{display: "block"}}>
            <ListItemButton onClick={
              () => {
                console.log(`action: ${item.action}`);
                item.action !== undefined ? item.action() : navigate(item.path)
              }
            }>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text}/>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Stack>
  );
};

export default MenuContent;
